import TextInputValidator from './TextInputValidator';
import InputTextListValidator from './InputTextListValidator';
import MultiLevelValidator from './MultiLevelValidator';
import RequiredRuleValidator from './RequiredRuleValidator';
import MonthYearValidator from './MonthYearValidator';
import { ControlType } from '../../../../../../../models/enums';
import { isAllowedValue } from '../../../../../../../services';

const controlShouldNotBeRequired = c =>
  c.type === ControlType.switch && isAllowedValue(c.defaultChecked);

// eslint-disable-next-line complexity
export function resolveValidationRule(control, errors = null) {
  const rules = [];
  switch (control.type) {
    case ControlType.inputText:
      rules.push({
        validator: (rule, value, callback) => TextInputValidator.validate(control,
          rule,
          value,
          callback),
      });
      break;
    case ControlType.suggestedAIDescription:
      rules.push({
        validator: (rule, value, callback) => TextInputValidator.validate(control,
          rule,
          value,
          callback),
      });
      break;

    case ControlType.horsePower:
      rules.push({
        validator: (rule, value, callback) =>
          TextInputValidator.validate(control, rule, value, callback)
      });
      break;

    case ControlType.money:
      rules.push({
        validator: (rule, value, callback) => TextInputValidator.validate(control,
          rule,
          value,
          callback),
      });
      break;

    case ControlType.monthYearPicker:
      rules.push({
        validator: (rule, value, callback) => MonthYearValidator.validate(control,
          rule,
          value,
          callback),
      });
      break;

    case ControlType.inputTextList:
      rules.push({
        validator: (rule, value, callback) => InputTextListValidator.validate(control,
          rule,
          value,
          callback),
      });
      break;

    default:
      break;
  }

  if (control.isRequired && !controlShouldNotBeRequired(control)) {
    if (control.type === ControlType.multiLevel) {
      rules.push({
        validator: (rule, value, callback) => MultiLevelValidator.validate(control,
          rule,
          value,
          callback, errors),
      });
    } else if (control.type !== ControlType.inputTextList) {
      rules.push(RequiredRuleValidator.validate(control));
    }
  }

  return rules;
}



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/ValidationRuleResolver/index.ts